import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from '../../../Config';
import SocialLinksBar from 'app/Components/Shared/SocialLinks/SocialLinks';
import googlePlay from './images/googleplay@4x.png';
import appStore from './images/appstore@4x.png';
import {buildUrlAndOpenWindow, buildUrlAndOpenSameWindow} from '../../../utilities/StringHelpers/StringHelpers';
import {DomainMarketCode} from '../../../utilities/domain/domainConstants.js';

const getFullPath = (url) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    return url;
  } else {
    return Config.staticWebSiteUrl + url;
  }
};

const getAnchorProps = (link) => {
  const handleClick = (e) => {
    e.preventDefault();
    const fullUrl = getFullPath(link.href);
    if (link.target === null) {
      link.target = '_top';
    }
    if (link.target === '_blank') {
      buildUrlAndOpenWindow(fullUrl);
    } else if (link.target === '_top' || link.target === '_self') {
      buildUrlAndOpenSameWindow(fullUrl);
    }
  };

  return {
    href: link.href,
    title: link.text,
    target: link.target || '#',
    rel: link.target === '_blank' ? 'noopener noreferrer' : undefined,
    onClick: handleClick,
  };
};

const renderLinkGroup = (title, links, button) => (
  <div className='columns'>
    <span>{title}</span>
    <ul>
      {links?.map((link, index) => (
        <li key={index}>
          <a {...getAnchorProps(link)}>{link.text}</a>
        </li>
      ))}
    </ul>
    {button && button.length > 0 && (
      <a {...getAnchorProps(button[0])} className='column-button'>
        {button[0].text}
      </a>
    )}
  </div>
);

const renderAppLinks = (googlePlayNavigation, appleStoreNavigation) => (
  <div className='social-icons'>
    <div className='icons'>
      <span>הורידו את אפליקציית {window.Config.brand_Name_HE} TV</span>
      <div className='google-apple'>
        <a href={getFullPath(googlePlayNavigation)}>
          <img src={googlePlay} alt='Google Play' />
        </a>
        <a href={getFullPath(appleStoreNavigation)}>
          <img src={appStore} alt='App Store' />
        </a>
      </div>
    </div>
  </div>
);

const isCellcomSite = window.__DOMAIN_MARKET_CODE__ === DomainMarketCode.CELLCOM;

const Footer = ({startPage: data}) => {
  return (
    <div className='footer-container'>
      <div className='logo-mobile'>
        {data.isCellcomEnergy?.value ? (
          <Image src={Config.epiBaseUrl + data.siteLogoCellcomEnergy?.value?.url} alt='Site Cellcom Energy Logo' />
        ) : (
          <Image src={Config.epiBaseUrl + data.siteLogo.value?.url} alt='Site Logo' />
        )}
      </div>
      <div className='columns-container'>
        {renderLinkGroup(data.linksTitleGroup1?.value, data.linksGroup1.value, data.buttonGroup1?.value)}
        {renderLinkGroup(data.linksTitleGroup2?.value, data.linksGroup2.value, data.buttonGroup2?.value)}
        {renderLinkGroup(data.linksTitleGroup3?.value, data.linksGroup3.value, data.buttonGroup3?.value)}
        {renderLinkGroup(data.linksTitleGroup4?.value, data.linksGroup4.value, data.buttonGroup4?.value)}

        <div className='columns-icons'>
          {isCellcomSite ? renderAppLinks(data.googlePlayNavigation.value, data.appleStoreNavigation.value) : null}
          <div className='social-container'>
            <SocialLinksBar startPage={data} />
          </div>
        </div>
        {data.regulatoryLegalText?.value && data.regulatoryTextUrl?.value && (
          <div className='legal-regulatory-text-container'>
            <span>{data.regulatoryLegalText?.value} לפרטים נוספים </span>
            <a
              href={
                data.regulatoryTextUrl?.value?.startsWith('/')
                  ? `${Config.staticWebSiteUrl}${data.regulatoryTextUrl?.value}`
                  : data.regulatoryTextUrl?.value
              }>
              לחץ כאן
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
